import styled from '@emotion/styled/macro';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as EquipmentIcon } from '../../svgs/cra-equipment-top-bar-icon.svg';
import Tooltip from '../../components/common/Tooltip';
import { dismissAllNotifications } from '../../store/equipment/equipmentActions';
import { toggleEquipmentPanel } from '../../store/ui/uiActions';
import { connect, useSelector } from 'react-redux';
import { selectEquipmentNotInOperation } from '../../store/api/selectors/equipment';
import { postEquipmentMetrics } from '../../store/api';
import { selectSystemsNotInOperation, selectEquipmentNotInOperationFilteredBySystemsNotInOperation } from '../../store/system/systemSelectors';

const StyledButton = styled.button`
  /* width: 2rem; */
  height: 2rem;
  /* position: absolute; */
  right: 30px;
  top: 15px;
  padding-left: 10px;
`;

const StyledMessage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  & span {
    cursor: pointer;
  }
`;

const StatusCenterButtonWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const StyledCounterBadge = styled.span`
  position: absolute;
  top: -4px;
  right: -6px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-observations);
  color: var(--color-dark);
  font-weight: bold;
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  border-radius: 7px;
  font-size: 0.6rem;
  line-height: 1;
  border: 2px solid var(--surface-1, #2d2f3c);
  pointer-events: none;
  ${(props) => (props.overrideWithStyle ? props.overrideWithStyle : null)};
`;

const EquipmentPanelButton = ({
  dismissAllNotifications,
  uiEquipmentPanelOpen,
  toggleEquipmentPanel,
}) => {
  const sessionId = useSelector((state) => state.api.sessionId);

  const handleEquipmentButtonClick = async () => {
    if (!uiEquipmentPanelOpen) {
      await postEquipmentMetrics(sessionId, 'EQUIPMENT_OPENED');
    }
    dismissAllNotifications([]);
    toggleEquipmentPanel(!uiEquipmentPanelOpen);
  };

  // We can add this line back in if we want the equipment to not be filtered by systems out of operation
  // const equipmentStatuses = useSelector(selectEquipmentNotInOperation);
  const equipmentStatuses = useSelector(selectEquipmentNotInOperationFilteredBySystemsNotInOperation);
  const systemStatuses = useSelector(selectSystemsNotInOperation);

  return (
    <StyledButton
      onClick={() => {
        handleEquipmentButtonClick();
      }}
    >
      <Tooltip
        message={
          <StyledMessage>
            <span>Status Center</span>
          </StyledMessage>
        }
      >
        <StatusCenterButtonWrapper className="status-center-button-wrapper">
          <EquipmentIcon fill="white" width="1.5rem" height="1.5rem" />
          {equipmentStatuses.length > 0 && (
            <StyledCounterBadge>
              {equipmentStatuses.length > 99 ? '99+' : equipmentStatuses.length}
            </StyledCounterBadge>
          )}
        </StatusCenterButtonWrapper>
      </Tooltip>
    </StyledButton>
  );
};

const mapStateToProps = (state) => ({
  uiEquipmentPanelOpen: state.ui.uiEquipmentPanelOpen,
});

const mapDispatchToProps = (dispatch) => ({
  dismissAllNotifications: (empty) => dispatch(dismissAllNotifications(empty)),
  toggleEquipmentPanel: (uiEquipmentPanelOpen) =>
    dispatch(toggleEquipmentPanel(uiEquipmentPanelOpen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentPanelButton);
